import {
    IonBackButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonLabel,
    IonListHeader,
    IonPage,
    IonTitle,
    IonToast,
    IonToolbar,
    useIonViewDidEnter
} from '@ionic/react';
import {
    arrowBack,
    listOutline,
    receiptOutline,
    removeCircleOutline,
    settingsOutline
} from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { MessageContext } from '../../../../../contexts/MessageContext';
import './MenuFiscal.css';

type Props = {
    abrirMenu: boolean;
};

const MenuFiscal: React.FC<Props> = (props: Props) => {
    const history = useHistory();
    const [showToast, setShowToast] = useState(false);
    const [textToast, setTextToast] = useState("");

    const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
    const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
    const { nomeMenu, setNomeMenu } = useContext(MessageContext);

    useIonViewDidEnter(() => {
        setEsconderMenu(true);
        setNomeMenu("");
    });

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar color="primary">
                    <IonButtons slot="start">
                        <IonBackButton icon={arrowBack} text='' />
                    </IonButtons>
                    <IonTitle slot="start">Fiscal</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent>

                <IonListHeader lines="full">NFC-e</IonListHeader>

                <IonItem lines="none" button routerLink="/empresa/fiscalemissao" routerDirection="forward" detail>
                    <IonIcon color='medium' slot="start" icon={receiptOutline} />
                    <IonLabel>Emitir NFC-e</IonLabel>
                </IonItem>

                <IonItem lines="none" button routerLink="/empresa/fiscalhistorico" routerDirection="forward" detail>
                    <IonIcon color='medium' slot="start" icon={listOutline} />
                    <IonLabel>Histórico de Notas</IonLabel>
                </IonItem>

                <IonListHeader lines="full">Administração</IonListHeader>

                <IonItem lines="none" button routerLink="/empresa/fiscalconfiguracoes" routerDirection="forward" detail>
                    <IonIcon color='medium' slot="start" icon={settingsOutline} />
                    <IonLabel>Configuração Fiscal</IonLabel>
                </IonItem>

                <IonItem lines="none" button routerLink="/empresa/fiscalinutilizacao" routerDirection="forward" detail>
                    <IonIcon color='medium' slot="start" icon={removeCircleOutline} />
                    <IonLabel>Inutilização de Numeração</IonLabel>
                </IonItem>

                <IonToast
                    isOpen={showToast}
                    position="middle"
                    onDidDismiss={() => setShowToast(false)}
                    message={textToast}
                    duration={3000}
                />
            </IonContent>
        </IonPage>
    );
};

export default MenuFiscal;
